import { useState } from "react";
import SyntaxHighlighter from 'react-syntax-highlighter';
import darkTheme from 'react-syntax-highlighter/dist/esm/styles/hljs/atom-one-dark';
import "./AppCodeSnippet.scss";
import { formatXML } from "../../constants/apiUtil";


const AppCodeSnippet = ({ snippet }) => {
	const code = snippet.replace("<pre>", "").replace("</pre>", "").trim();
	const [copied, setCopied] = useState(false);
	const formattedXML = formatXML(code, '    ');
	const handleClick = () => {
		navigator.clipboard.writeText(formattedXML).then(() => {
			setCopied(true);
			setTimeout(() => {
				setCopied(false);
			}, 2000);
		}).catch((err) => {
			console.log('Failed to copy: ', err);
		}
		)
	};
	return (
		<div className="code-container">
			<button onClick={handleClick}>{copied ? 'Copied!' : 'Copy'}</button>
			<SyntaxHighlighter language="xml" style={darkTheme} showLineNumbers>{formattedXML}</SyntaxHighlighter>
		</div>
	);
};

export default AppCodeSnippet;
